import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: "website" | "article";
  siteName?: string;
  locale?: string;
}

export function SEO({
  title,
  description,
  keywords = "healthy drinks, ragi drink, ganji, ganji drinks, millet drink, finger millet beverage, traditional Indian drink, healthy beverage Bangalore, ready to drink ragi, desi energy drink, ragi malt, ragi java, best healthy drinks India, natural energy drink, organic drink India, protein drink, wellness drink, superfood drink, calcium rich drink, iron rich drink, post workout drink, morning drink India, summer drink India, refreshing drinks, nutritious drinks, low calorie drink, vegan drink India, drinks near me, healthy beverages online, millet beverages, ragi health benefits, meal replacement drink India, cheap healthy drink India",
  image = "https://ganjidrinks.shop/images/independence-social-preview.jpg",
  url = "https://ganjidrinks.shop",
  type = "website",
  siteName = "Ganji Drinks",
  locale = "en_US",
}: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <meta name="author" content="Ganji Drinks" />
      <meta name="theme-color" content="#602810" />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": siteName,
          "alternateName": ["Ganji", "Ganjidrinks", "Ganji Ragi Drink"],
          "url": url,
          "description": description,
          "inLanguage": "en-IN",
          "publisher": {
            "@type": "Organization",
            "name": siteName,
            "url": url,
            "logo": {
              "@type": "ImageObject",
              "url": `${url}/images/ganjidrinks-logo.png`,
              "width": 512,
              "height": 512,
            },
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": siteName,
          "alternateName": ["Ganji", "Ganjidrinks", "Healthy Ragi Drink"],
          "url": url,
          "logo": `${url}/images/ganjidrinks-logo.png`,
          "description": "Traditional Indian ragi drink brand bringing ready-to-drink millet beverages to modern consumers.",
          "areaServed": "Bangalore, India",
          "sameAs": [
            "https://x.com/ganjidrinks",
            "https://www.instagram.com/ganjidrinks/",
            "https://www.linkedin.com/company/its-ganjidrinks/",
            "https://whatsapp.com/channel/0029VbBbmYKAInPhJvL4Iy3s",
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+919019323880",
            "contactType": "customer service",
            "availableLanguage": ["English", "Hindi", "Kannada"],
          },
        })}
      </script>
    </Helmet>
  );
}
